var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/consts.ts
var LOG_URL = "api/log";
var VM_EXPOSED_LOCALHOST_IP = "10.211.55.2";
var VM_LOCALHOST_ALIAS = "your_mac_ip:";

// src/getRateLimiter.ts
import { RateLimiter } from "limiter";
var getRateLimiter = (tokensPerInterval = 30, interval = "min", fireImmediately = true) => {
  return new RateLimiter({
    tokensPerInterval,
    interval,
    fireImmediately
  });
};

// src/types.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["DEBUG"] = "debug";
  LogLevel2["INFO"] = "info";
  LogLevel2["WARNING"] = "warning";
  LogLevel2["ERROR"] = "error";
  LogLevel2["CRITICAL"] = "critical";
  return LogLevel2;
})(LogLevel || {});
var BackendService = /* @__PURE__ */ ((BackendService2) => {
  BackendService2["CONSOLE"] = "console";
  BackendService2["LOGGER"] = "logger";
  return BackendService2;
})(BackendService || {});

// src/mapBackendServiceToPort.ts
var mapBackendServiceToPort = (service) => {
  switch (service) {
    case "console" /* CONSOLE */:
      return "6002";
    case "logger" /* LOGGER */:
      return "6025";
    default:
      throw new Error(`Unexpected service value: ${service}`);
  }
};

// src/getUrlByEnv.ts
var getUrlByEnv = (origin, service, path) => {
  if (origin.includes("staging"))
    return new URL(path, `https://${service}.staging.getvim.com`).href;
  else if (origin.includes("demo"))
    return new URL(path, `https://${service}.demo.getvim.com`).href;
  else if (origin.includes("localhost")) {
    return new URL(path, `http://localhost:${mapBackendServiceToPort(service)}`).href;
  } else if (origin.includes("dev")) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else if (origin.includes(VM_EXPOSED_LOCALHOST_IP)) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else if (origin.includes(VM_LOCALHOST_ALIAS)) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else
    return new URL(path, `https://${service}.getvim.com`).href;
};
function getEnvByOrigin(origin) {
  if (origin.includes("staging")) {
    return "staging";
  } else if (origin.includes("dev")) {
    return "dev";
  } else if (origin.includes("demo")) {
    return "demo";
  } else if (origin.includes("localhost")) {
    return "dev";
  } else if (origin.includes(VM_EXPOSED_LOCALHOST_IP)) {
    return "dev";
  } else if (origin.includes(VM_LOCALHOST_ALIAS)) {
    return "dev";
  } else {
    return "prod";
  }
}
var getSumoCapacitorUrlByEnv = (origin, logLevel) => {
  if (logLevel === "info" /* INFO */) {
    logLevel = "other";
  }
  const path = `${logLevel}.log`;
  const env = getEnvByOrigin(origin);
  return new URL(path, `https://client-logs${env === "prod" ? "." : `.${env}.`}getvim.com/`).href;
};

// src/scopeColors.ts
var scopeColors = [
  "#63b598",
  "#ce7d78",
  "#ea9e70",
  "#a48a9e",
  "#648177",
  "#0d5ac1",
  "#f205e6",
  "#14a9ad",
  "#4ca2f9",
  "#a4e43f",
  "#d298e2",
  "#6119d0",
  "#d2737d",
  "#c0a43c",
  "#f2510e",
  "#651be6",
  "#79806e",
  "#61da5e",
  "#cd2f00",
  "#9348af",
  "#01ac53",
  "#996635",
  "#b11573",
  "#4bb473",
  "#75d89e",
  "#2f3f94",
  "#2f7b99",
  "#da967d",
  "#34891f",
  "#b0d87b",
  "#ca4751",
  "#7e50a8",
  "#c4d647",
  "#11dec1",
  "#289812",
  "#566ca0",
  "#2f1179",
  "#935b6d",
  "#916988",
  "#513d98",
  "#aead3a",
  "#9e6d71",
  "#4b5bdc",
  "#0cd36d",
  "#cb5bea",
  "#228916",
  "#ac3e1b",
  "#df514a",
  "#539397",
  "#880977",
  "#ba96ce",
  "#679c9d",
  "#c6c42c",
  "#5d2c52",
  "#48b41b",
  "#e1cf3b",
  "#5be4f0",
  "#57c4d8",
  "#a4d17a",
  "#225b80",
  "#be608b",
  "#96b00c",
  "#088baf",
  "#f158bf",
  "#e145ba",
  "#05d371",
  "#5426e0",
  "#4834d0",
  "#802234",
  "#6749e8",
  "#0971f0",
  "#8fb413",
  "#c9a941",
  "#41d158",
  "#fb21a3",
  "#51aed9",
  "#5bb32d",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#3b8c2a",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#521250",
  "#d6dd92",
  "#e33e52",
  "#b2be57",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#e33e52",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#64820f",
  "#9cb64a",
  "#996c48",
  "#9ab9b7",
  "#06e052",
  "#0eb621",
  "#fc458e",
  "#b2db15",
  "#aa226d",
  "#792ed8",
  "#73872a",
  "#7d1d85",
  "#c4fd57",
  "#f1ae16",
  "#8fe22a",
  "#ef6e3c",
  "#243eeb",
  "#1dc180",
  "#3f8473",
  "#7a3d93",
  "#93f2d7",
  "#9b5c2a",
  "#15b9ee",
  "#0f5997",
  "#409188",
  "#911e20",
  "#1350ce",
  "#10e5b1",
  "#cb2582",
  "#ce00be",
  "#32d5d6",
  "#608572",
  "#c79bc2",
  "#00f87c",
  "#77772a",
  "#6995ba",
  "#fc6b57",
  "#f07815",
  "#8fd883",
  "#96e591",
  "#21d52e",
  "#d00043",
  "#1ec227",
  "#947002",
  "#bde052",
  "#e08c56",
  "#28fcfd",
  "#bb09b0",
  "#36486a",
  "#d02e29",
  "#1ae6db",
  "#3e464c",
  "#a84a8f",
  "#911e7e",
  "#0f525f",
  "#ac7c0a",
  "#b4c086",
  "#c9d730",
  "#30cc49",
  "#3d6751",
  "#fb4c03",
  "#640fc1",
  "#62c03e",
  "#d3493a",
  "#88aa0b",
  "#406df9",
  "#615af0",
  "#4be470",
  "#2a3434",
  "#4a543f",
  "#79bca0",
  "#00efd4",
  "#7ad236",
  "#7260d8",
  "#1deaa7",
  "#06f43a",
  "#823c59",
  "#e3d94c",
  "#dc1c06",
  "#f53b2a",
  "#b46238",
  "#2dfff6",
  "#a82b89",
  "#1a8011",
  "#436a9f",
  "#1a806a",
  "#4cf09d",
  "#67eb4b",
  "#b308d3",
  "#fc7e41",
  "#af3101",
  "#ff0650",
  "#71b1f4",
  "#a2f8a5",
  "#e23dd0",
  "#d3486d",
  "#00f7f9",
  "#474893",
  "#3cec35",
  "#1c65cb",
  "#5d1d0c",
  "#2d7d2a",
  "#ff3420",
  "#5cdd87",
  "#a259a4",
  "#e4ac44",
  "#1bede6",
  "#8798a4",
  "#d7790f",
  "#b2c24f",
  "#de73c2",
  "#d70a9c",
  "#25b670",
  "#88e9b8",
  "#86e98f",
  "#1a806b",
  "#436a9e",
  "#0ec0ff",
  "#f812b3",
  "#b17fc9",
  "#8d6c2f",
  "#d3277a",
  "#2ca1ae",
  "#9685eb",
  "#8a96c6",
  "#76fc1b",
  "#608fa4",
  "#20f6ba",
  "#07d7f6",
  "#77ecca"
];

// src/logToConsole.ts
var selectScopeColor = (scope, colors = scopeColors) => {
  let hash = 0;
  for (let i = 0; i < scope.length; i++) {
    hash = (hash << 5) - hash + scope.charCodeAt(i);
    hash |= 0;
  }
  return colors[Math.abs(hash) % colors.length];
};
var VIM_CONNECT_BG_COLOR = "#09ACE4";
var scopeConsoleLog = (scope, options) => {
  const { moduleAndScopeSameColor, moduleName } = options || {};
  const scopeColor = selectScopeColor(scope);
  return (level, message, data, options2) => {
    const { messageStyle = [] } = options2 || {};
    const levelStyle = getLogLevelStyle(level);
    const method = level === "debug" /* DEBUG */ ? "debug" : "log";
    console[method](`%c ${moduleName ?? "Vim Connect"} %c (${level}) %c [${scope}] %c ${message || "(no message)"}`, `background: ${moduleAndScopeSameColor ? scopeColor : VIM_CONNECT_BG_COLOR}; color: white;`, levelStyle, `color: ${scopeColor};`, "", ...messageStyle, data || "");
  };
};
var logToConsole = (level, message, data) => {
  console.log(`%c Vim Extension %c (${level}) %c ${message || "(no message)"}`, "background: #083A6B; color: white;", `${getLogLevelStyle(level)}`, "", data || "");
};
function getLogLevelStyle(logLevel) {
  switch (logLevel) {
    case "warning" /* WARNING */:
      return "background: #EEAA79";
    case "error" /* ERROR */:
      return "background: #BC2214";
    case "critical" /* CRITICAL */:
      return "background: red";
    default:
      return "";
  }
}

// src/ScopedLogger.ts
import { Team } from "@getvim/vim-code-ownership/team";
var TIMEOUT = 15e4;
var Logger = class {
  info(message, data, options, tags) {
    this.log("info" /* INFO */, message, data, options, tags);
  }
  error(message, data, options, tags) {
    this.log("error" /* ERROR */, message, data, options, tags);
  }
  debug(message, data, options, tags) {
    this.log("debug" /* DEBUG */, message, data, options, tags);
  }
  warning(message, data, options, tags) {
    this.log("warning" /* WARNING */, message, data, options, tags);
  }
};
var _ScopedLogger = class extends Logger {
  constructor(scope, options, tags = {}) {
    super();
    this.scope = scope;
    this.tags = tags;
    this.defineJsonStringifyOnError();
    const moduleName = _ScopedLogger.moduleName || options?.moduleName || tags?.moduleName || (this.isLoggerInWebWorker ? void 0 : window?.$vim_environment?.service) || void 0;
    this.consoleLog = scopeConsoleLog(scope, options ? { ...options, moduleName } : {
      moduleName
    });
    this.rateLimiter = getRateLimiter();
    try {
      const deviceId = new URLSearchParams(globalThis.location.search).get("deviceId");
      if (deviceId) {
        _ScopedLogger.setDeviceId(deviceId);
      }
    } catch (error) {
      console.error("failed to get deviceId from URL for initLoggerDeviceId", error);
    }
    const useCapacitorByEnv = globalThis.$vim_environment?.VIM_USE_SUMO_CAPACITOR_V2;
    if (useCapacitorByEnv != void 0) {
      this.useCapacitor = useCapacitorByEnv?.toLowerCase() === "true";
    }
    this.consoleLogLevelFromStorage = !this.isLoggerInWebWorker ? localStorage.getItem("VIM_CONSOLE_LOG_LEVEL") : "debug" /* DEBUG */;
  }
  static setMetadata(metadata) {
    this.metadata = {
      ...metadata,
      adapterName: metadata.adapterName?.toLowerCase()
    };
  }
  static setUserMetadata(userMetadata) {
    this.userMetadata = {
      id: userMetadata?.id,
      createdAt: userMetadata?.createdAt,
      updatedAt: userMetadata?.updatedAt,
      activatedAt: userMetadata?.activatedAt,
      externalId: userMetadata?.externalId,
      npi: userMetadata?.npi,
      tin: userMetadata?.tin,
      firstName: userMetadata?.firstName,
      lastName: userMetadata?.lastName,
      linkedEhrUser: userMetadata?.linkedEhrUser,
      tag: userMetadata?.tag,
      title: userMetadata?.title,
      address: userMetadata?.address,
      organizationId: userMetadata?.organization?.id,
      products: userMetadata?.products?.map((i) => i?.name)
    };
  }
  static updateMetadata(paramsToUpdate) {
    this.metadata = {
      ...this.metadata,
      ...paramsToUpdate
    };
    if (this.metadata.adapterName)
      this.metadata.adapterName = this.metadata.adapterName.toLowerCase();
  }
  static setStaticTags(tags) {
    this.staticTags = {
      ...tags
    };
  }
  static setDeviceId(deviceId) {
    this.metadata = {
      version: "unknown",
      windowId: "unknown",
      ...this.metadata,
      deviceId
    };
  }
  static setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }
  static setRemoteLogSupported(supported) {
    this.remoteLogSupported = supported;
  }
  static setLimiterSupported(supported) {
    this.limiterSupported = supported;
  }
  static setOnLog(onLog) {
    this.onLog = onLog;
  }
  static setModuleName(moduleName) {
    this.moduleName = moduleName;
  }
  useCapacitor = true;
  isBlocked = false;
  rateLimiter;
  consoleLog;
  consoleLogLevelFromStorage;
  get isLoggerInWebWorker() {
    return typeof self.WorkerGlobalScope !== "undefined" && self instanceof self.WorkerGlobalScope;
  }
  getOriginSafe() {
    return globalThis?.location?.origin || "";
  }
  getConsoleLogLevelByEnv() {
    return getEnvByOrigin(this.getOriginSafe()) === "prod" ? "disable" : "debug";
  }
  logLevelOrder = {
    ["disable"]: 1,
    ["critical" /* CRITICAL */]: 2,
    ["error" /* ERROR */]: 3,
    ["warning" /* WARNING */]: 4,
    ["warn"]: 4,
    ["info" /* INFO */]: 5,
    ["debug" /* DEBUG */]: 6
  };
  shouldLogConsole(level) {
    const consoleLogLevelString = globalThis.$vim_environment?.VIM_CONSOLE_LOG_LEVEL ?? this.consoleLogLevelFromStorage ?? this.getConsoleLogLevelByEnv();
    return this.logLevelOrder[level] <= this.logLevelOrder[consoleLogLevelString];
  }
  async log(level, message, data, options, tags) {
    if (this.shouldLogConsole(level))
      this.consoleLog(level, message, data, options);
    const shouldSendToBackendByLevel = level !== "debug" /* DEBUG */;
    const origin = this.getOriginSafe();
    const time = Date.now();
    const remainingRequests = shouldSendToBackendByLevel ? await this.rateLimiter.removeTokens(1) : this.rateLimiter.getTokensRemaining();
    if (this.shouldLog(remainingRequests)) {
      this.isBlocked = false;
      _ScopedLogger.onLog?.(level, message, data);
      if (!options?.local && _ScopedLogger.remoteLogSupported) {
        const request = this.buildRequestInit(data, level, message, time, tags);
        return shouldSendToBackendByLevel && await this.sendToLoggerService(origin, request, level);
      }
    } else {
      const message2 = `Scopped logger get blocked due reaching rate limit`;
      const request = this.buildRequestInit({}, "warning" /* WARNING */, message2, time, tags);
      !this.isBlocked && shouldSendToBackendByLevel && this.sendToLoggerService(origin, request, level);
      this.isBlocked = true;
    }
  }
  buildRequestInit(data, logLevel, message, clientTime, tags) {
    return this.useCapacitor ? this.buildCapacitorRequestInit(data, logLevel, message, clientTime, tags) : this.buildOldRequestInit(data, logLevel, message, clientTime, tags);
  }
  buildOldRequestInit(data, logLevel, message, clientTime, tags) {
    const { metadata, staticTags, accessToken } = _ScopedLogger;
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...accessToken ? { authorization: accessToken } : void 0
      },
      body: JSON.stringify({
        scope: this.scope,
        message,
        data,
        logLevel,
        clientTime,
        metadata: {
          tabVisibility: this.isLoggerInWebWorker ? void 0 : document.visibilityState,
          ...metadata
        },
        tags: {
          ...staticTags,
          ...this.tags,
          ...tags,
          vimVersion: globalThis?.$vim_environment?.vim_version,
          version: globalThis?.$vim_environment?.version
        }
      })
    };
    return request;
  }
  buildCapacitorRequestInit(data, logLevel, message, clientTime, tags) {
    const { metadata, staticTags, accessToken, moduleName } = _ScopedLogger;
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...accessToken ? { authorization: accessToken } : void 0
      },
      body: JSON.stringify({
        log: {
          level: logLevel,
          moduleName,
          scope: this.scope,
          message,
          metadata: {
            scope: this.scope,
            userMetadata: _ScopedLogger.userMetadata,
            data,
            clientTime,
            metadata: {
              tabVisibility: this.isLoggerInWebWorker ? void 0 : document.visibilityState,
              ...metadata
            },
            tags: { ...staticTags, ...this.tags, ...tags }
          }
        }
      })
    };
  }
  shouldLog(remainingRequests) {
    return !_ScopedLogger.limiterSupported || remainingRequests >= 0;
  }
  async sendToLoggerService(origin, request, logLevel, timeout = TIMEOUT) {
    if (origin.includes("localhost"))
      return;
    const controller = new AbortController();
    setTimeout(() => {
      controller.abort();
    }, timeout);
    if (this.useCapacitor) {
      fetch(`${getSumoCapacitorUrlByEnv(origin, logLevel)}`, {
        ...request,
        signal: controller.signal
      }).catch((error) => {
        if (error?.name !== "AbortError") {
          throw error;
        }
      });
    } else {
      fetch(`${getUrlByEnv(origin, "logger" /* LOGGER */, LOG_URL)}`, {
        ...request,
        signal: controller.signal
      }).catch((error) => {
        if (error?.name !== "AbortError") {
          throw error;
        }
      });
    }
  }
  defineJsonStringifyOnError() {
    if (!("toJSON" in Error.prototype)) {
      Object.defineProperty(Error.prototype, "toJSON", {
        value: function() {
          const alt = {};
          Object.getOwnPropertyNames(this).forEach((key) => {
            alt[key] = this[key];
          }, this);
          return alt;
        },
        configurable: true,
        writable: true
      });
    }
  }
};
var ScopedLogger = _ScopedLogger;
__publicField(ScopedLogger, "metadata");
__publicField(ScopedLogger, "staticTags");
__publicField(ScopedLogger, "onLog");
__publicField(ScopedLogger, "accessToken");
__publicField(ScopedLogger, "remoteLogSupported", true);
__publicField(ScopedLogger, "limiterSupported", true);
__publicField(ScopedLogger, "userMetadata");
__publicField(ScopedLogger, "moduleName");

// src/VimConnectLogger.ts
var VimConnectLogger = class {
  setModuleName(moduleName) {
    ScopedLogger.setModuleName(moduleName);
  }
  setMetadata(metadata) {
    ScopedLogger.setMetadata(metadata);
  }
  setUserMetadata(userMetadata) {
    ScopedLogger.setUserMetadata(userMetadata);
  }
  updateMetadata(paramsToUpdate) {
    ScopedLogger.updateMetadata(paramsToUpdate);
  }
  setStaticTags(tags) {
    ScopedLogger.setStaticTags(tags);
  }
  setDeviceId(deviceId) {
    ScopedLogger.setDeviceId(deviceId);
  }
  setAccessToken(accessToken) {
    ScopedLogger.setAccessToken(accessToken);
  }
  setRemoteLogSupport(supported) {
    ScopedLogger.setRemoteLogSupported(supported);
  }
  setLimiterSupport(supported) {
    ScopedLogger.setLimiterSupported(supported);
  }
  setOnLog(onLog) {
    ScopedLogger.setOnLog(onLog);
  }
  scope(scope, options, tags = {}) {
    return new ScopedLogger(scope, options, tags);
  }
};
var logger = new VimConnectLogger();

// src/mocks/logger-factory.mock.ts
var MockLogger = class extends Logger {
  log() {
  }
};
var mockLogger = new MockLogger();
export {
  BackendService,
  LogLevel,
  Logger,
  ScopedLogger,
  Team,
  logToConsole,
  logger,
  mockLogger,
  scopeConsoleLog
};
//# sourceMappingURL=index.js.map
